import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig, //寄送，支付接口
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';
import NProgress from 'nprogress';
import $http from '$http';
import chooseDialog from "@pages/Order/MeetOrder/components/chooseDialog/index.vue" //选择代理商、园所弹窗
import AddressDialog from "@pages/SchoolOrder/components/AddressDialog/index.vue" // 选择收货地址弹窗
import optOpenClassDialog from '@pages/Order/components/optOpenClassDialog/index.vue'; //添加幼儿园（原开课申请）
import payTypeInfo from '@pages/Order/MeetOrder/components/payTypes/index.vue'; //支付方式


export default {
    mixins: [services],
    components: {
        chooseDialog,
        AddressDialog,
        optOpenClassDialog,
        payTypeInfo,
    },
    props: {
        value: {
            type: Boolean,
            default: null
        },
    },
    created() {


        // this.getPay(8);
        // this.getPay(9);

    },
    data() {
        return {
            num: 1,
            loading: false,
            agent: '',
            school: '',
            transportList: [], //寄送方式
            PayList: [], //支付方式
            form: this.getSubmitFormData(),
            SchoolConsigneeList: [],
            ConsigneeList: '', //收货地址
            ConsigneeListName: '', //联系人及电话
            AddDialogVisible: false,
            showData: this.getShowData(), //弹窗传参
            pageIndex: 1,
            pageSize: 10,
            minNum: 1,
            maxNum: Infinity,
            isOpen: false, //是否开班
            isDelShow: [false],
            payTypesArea: [],
            payList: [{}],
            addDialogVisiable: false, //新增代理商
            ListData: [],
            PayListData: [],
            PackageName: "",
            packages: [{
                Id: 500,
                label: "续费A套餐"
            }, {
                Id: 501,
                label: "续费B套餐"
            }, {
                Id: 502,
                label: "续费C套餐"
            }],
            PackageDetails: [], //资源包
            ClassNum: 1,
            debtPackage: 0, //未提货资源包（即所欠资源包套数）
            addressData: this.getAddressData(),

        }
    },
    methods: {
        getAddressData() {
            return cloneDeep({
                // 修改地址提交数据
                "ConsigneeProvId": 0,
                "ConsigneeCityId": 0,
                "ConsigneeAreaId": 0,
                "ConsigneeAddress": "",
                "Consignee": "",
                "ConsigneeTel": "",
            });
        },

        getSubmitFormData() {
            return cloneDeep({
                "OrderId": 0,
                "AgentId": 0,
                "SchoolId": 0,
                "ClassNum": 1,
                "PackageId": "",
                "SchoolConsigneeId": 0,
                OrderPostPrice: 0,
                "SendMode": 223,
                "PayMode": 222,
                "GoodsList": [],
                "VirtualList": [],
                "OrderPrice": 0,
                //支付方式
                "ListMeetPay": [],
                "PayObject": null, //支付对象
                "Remark": "",

            });
        },

        addFn() {
            this.payList.push({})
            this.isDelShow.push(true)
        },
        delPayFn(item) {
            this.payList.splice((item.index - 1), 1);

        },
        //添加幼儿园
        addSchool() {
            if (this.form.AgentId == 0) {
                this.$notify({
                    title: '警告',
                    message: '请先选择代理商',
                    type: 'warning'
                });
            } else {
                this.$refs.refoptOpenClassDialog.show({
                    AgentId: this.form.AgentId,
                    isAdd: true,
                    SchoolCome: 5,
                    isShowImg: false
                })
            }
        },
        getSchoolName(item) {
            //添加幼儿园后默认选中当前添加的幼儿园
            //item.SyncSchoolId存在则显示同步幼儿园后数据
            console.log(item)
            this.school = item.SchoolName + '  ' + item.PrincipalName + '  ' + item.PhoneNo
            this.form.SchoolId = item.SchoolId
            this.getSchoolConsigneeList(this.form.SchoolId)

        },
        // 获取组件chooseDialog 值
        getDialogList(item) {
            // 切换代理商或园所重置资源包数据
            this.debtPackage = 0
            this.form.PayObject = null;
            if (item.title == '选择代理商') {
                this.agent = item.Customer + '   ' + item.Address + '   ' + item.AgentTel
                this.form.AgentId = item.Id,
                    this.school = '',
                    this.form.SchoolId = 0,
                    this.ConsigneeList = '',
                    this.ConsigneeListName = ''
            } else {
                this.school = item.SchoolName + '   ' + item.PrincipalName + '   ' + item.PhoneNo
                this.form.SchoolId = item.Id

                this.getSchoolConsigneeList(this.form.SchoolId) //点击园所之后获取默认收货地址





            }
        },
        //获取选择弹窗收货地址
        getAddress(item) {
            this.addressData.ConsigneeProvId = item.ConsigneeProvince
            this.addressData.ConsigneeCityId = item.ConsigneeCity
            this.addressData.ConsigneeAreaId = item.ConsigneeArea
            this.addressData.ConsigneeAddress = item.ConsigneeAdress
            this.addressData.Consignee = item.Consignee
            this.addressData.ConsigneeTel = item.ConsigneeTel

            this.ConsigneeList = item.ConsigneeProvinceName + '  ' + item.ConsigneeCityName + '  ' + item.ConsigneeAreaName + '  ' + item.ConsigneeAdress
            this.ConsigneeListName = item.Consignee + '  ' + item.ConsigneeTel
            //this.form.SchoolConsigneeId = 0 //代表新增
        },
        // 选择代理商
        chooseAgent() {
            this.$refs.chooseDialog.show({
                title: '选择代理商',
                isHiB: true
            });

        },
        //选择园所
        chooseSchool() {
            if (this.form.AgentId == 0) {
                this.$notify({
                    title: '警告',
                    message: '请先选择代理商',
                    type: 'warning'
                });
            } else {
                this.$refs.chooseDialog.show({
                    title: '选择园所',
                    AgentId: this.form.AgentId,

                });

            }

        },
        //修改园所收货地址
        changeAddress() {
            this.$nextTick(() => {
                this.$refs.AddressDialog.show({
                    SchoolId: this.form.SchoolId,
                    address: this.addressData,
                    Id: this.form.SchoolConsigneeId
                });
            })

        },
        getShowData() {
            return cloneDeep({
                SchoolId: 0,
                title: '',
                isReadOnly: false,
                ClassNum: 0, //总开班数，
                schoolTitle: "园所",
                PackageId: "",

            });
        },
        //初始化数据
        initData() {
            this.form = this.getSubmitFormData()
            this.showData = this.getShowData()
            this.addressData = this.getAddressData()
            this.debtPackage = 0
            this.school = ""
            this.agent = ""
            this.ConsigneeList = ''
            this.ConsigneeListName = ''
            this.PackageName = ''
            this.payList = [{}]
            this.loading = false
        },
        show(options) {
            this.initData();
            this.AddDialogVisible = true
            this.showData.title = options.title
            this.getDetailsPackage()
            // 设置数据
            if (options.message) {
                this.form.AgentId = options.message.AgentId
                this.agent = options.message.AgentName + ' , ' + options.message.C_Name + '  ' + options.message.PhoneNo
                this.school = options.message.SchoolName
                this.form.SchoolId = options.message.SchoolId
                this.showData.PackageId = options.message.PackageId

            }

            if (this.showData.title == '修改订单' || this.showData.title == '查看订单') {

                this.showData.isReadOnly = options.isReadOnly
                this.form.OrderId = options.message.OrderId
                this.getList(this.form.OrderId)

            }


        },
        submit() {
            this.form.OrderPrice = this.price;
            this.form.OrderPostPrice = this.postage
            //"GoodsList": [],//配套实物商品 
            this.form.GoodsList = []
            //两个套餐资源包ui一致
            this.form.GoodsList = this.PackageDetails
            // 判断是都选择套餐
            for (let i = 0; i < this.form.GoodsList.length; i++) {
                if (this.form.GoodsList[i].ProId == '') {
                    this.$notify({
                        title: '警告',
                        message: '请选择套餐',
                        type: 'warning'
                    });
                    return;
                }
            }
            // 支付方式
            this.form.ListMeetPay = []
            for (let i = 0; i < this.payList.length; i++) {
                // 价格为0时不需要填写支付信息
                if (this.form.OrderPrice > 0) {
                    let data = this.$refs['payInfo' + (i + 1)][0].validate();
                    if (!data) {
                        return;
                    }
                    this.form.ListMeetPay.push(data);
                } else {
                    this.form.ListMeetPay = []
                }
            }

            let rule = [{
                name: "代理商",
                value: this.agent,
                required: true,
            }, {
                name: "园所",
                value: this.school,
                required: true,
            }, {
                name: "支付对象",
                value: this.form.PayObject,
                required: true,
            }];

            var flag = util.checkForm({
                ele: this,
                rules: rule
            });

            if (!flag) {
                return;
            }
            if (this.totalNum == 0) {
                this.$confirm('当前订单未配置任何资源包,是否确定下单？', '提示', {}).then(() => {
                    if (this.form.OrderId == 0) {
                        this.getAddOrderList(); //会销开课
                    } else {
                        this.getUpdateOrderList() //修改
                    }
                });
            } else {
                if (this.form.OrderId == 0) {
                    this.getAddOrderList(); //会销开课
                } else {
                    this.getUpdateOrderList() //修改
                }
            }
            // if (this.form.OrderId == 0) {
            //     this.getAddOrderList(); //会销开课
            // } else {
            //     this.getUpdateOrderList() //修改
            // }
        }
    },
    computed: {
        // 资源包单价
        UnitPrice() {
            if (this.form.PayObject == 0) {
                // 园所
                if (this.form.PackageId == 500) {
                    return 3500
                } else if (this.form.PackageId == 501) {
                    return 5000

                } else if (this.form.PackageId == 502) {
                    return 18000
                }

            } else if (this.form.PayObject == 1) {
                //代理商
                if (this.form.PackageId == 500) {
                    return 2750
                } else if (this.form.PackageId == 501) {
                    return 4500

                } else if (this.form.PackageId == 502) {
                    return 16000
                }
            }
            return 0
        },
        // 总资源包套数
        totalNum() {
            let num = 0
            // D套餐1012
            for (let i = 0; i < this.PackageDetails.length; i++) {
                num += this.PackageDetails[i].ProNum
            }
            return num
        },
        // 至少配置资源包总数
        packagesNum() {
            if (this.form.PackageId == 500) {
                return 15 * this.form.ClassNum
            } else if (this.form.PackageId == 501) {
                return 30 * this.form.ClassNum
            } else if (this.form.PackageId == 502) {
                return 90 * this.form.ClassNum
            }
            return 0
        },
        // 邮费
        postage() {
            if (this.totalNum > 0 && this.totalNum - this.packagesNum > 0) {
                if (this.addressData.ConsigneeProvId == 131 || this.addressData.ConsigneeProvId == 132 || this.addressData.ConsigneeProvId == 133) {
                    //江浙沪地区131 132 133
                    if (this.totalNum - this.packagesNum <= 30) {
                        return 12
                    } else {
                        return ((this.totalNum - this.packagesNum) * 0.4).toFixed(2)
                    }
                } else {
                    // 非江浙沪地区
                    if (this.totalNum - this.packagesNum <= 30) {
                        return 19
                    } else {
                        return ((this.totalNum - this.packagesNum) * 0.63).toFixed(2)
                    }
                }
            } else {
                return 0;
            }



        },
        //资源包价格
        price() {
            if (this.totalNum > this.packagesNum) {

                return (this.UnitPrice * this.form.ClassNum + (this.totalNum - this.packagesNum) * 17.80).toFixed(2)

            } else {
                return this.UnitPrice * this.form.ClassNum
            }
            return 0

        },
        totalPrice() {
            return (this.postage * 1 + this.price * 1).toFixed(2)
        },
    },
}


// WEBPACK FOOTER //
// ./src/pages/Order/HiOrder/addOrderDialog/vm.js